import { fetchGet, toQueryString } from "../../../../../service/api_client";

export const ScannedBarCodeScanForDeviceFromPTAPI = async (
  item_code: string,
  warehouse: string,
  scanned_id: string
) => {
  try {
    const url =
      `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/journal/sender_transfer/get-devices-pt` +
      toQueryString({
        item_code: item_code,
        warehouse: warehouse,
        scanned_id: scanned_id,
      });
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return { success: false };
  }
};

export const ScannedBarCodeScanForDeviceIDFromPTAPI = async (
  item_code: string,
  warehouse: string,
  scanned_id: string,
) => {
  try {
    const url =
      `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase/scan-device-id-grn-pt` +
      toQueryString({
        item_code: item_code,
        warehouse: warehouse,
        scanned_id: scanned_id,
      });
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return { success: false };
  }
};
